import { useState, type ImgHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface AvatarProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'size'> {
  src?: string;
  name?: string;
  size?: number;
}

function initials(name?: string): string {
  if (!name) return '?';
  const cleaned = name.replace(/\.(eth|bnb)$/i, '').replace(/[^a-zA-Z0-9 ]/g, ' ').trim();
  if (!cleaned) return '?';
  const parts = cleaned.split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

export function Avatar({ src, name, size = 36, className, alt, ...rest }: AvatarProps) {
  const [errored, setErrored] = useState(false);
  const dimension = { width: size, height: size };
  const showImg = src && !errored;

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-water-100 text-ink-900 font-semibold',
        className,
      )}
      style={dimension}
      aria-hidden={alt ? undefined : true}
    >
      {showImg ? (
        <img
          src={src}
          alt={alt ?? name ?? ''}
          width={size}
          height={size}
          onError={() => setErrored(true)}
          className="h-full w-full object-cover"
          {...rest}
        />
      ) : (
        <span style={{ fontSize: Math.max(10, size * 0.36) }}>{initials(name)}</span>
      )}
    </span>
  );
}

export default Avatar;
